var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ib-col flex" },
    [
      _c("div", { staticClass: "ib-row" }, [
        _c("div", { staticClass: "ib-col" }, [
          _c("h1", { staticClass: "insety-32" }, [
            _vm._v(_vm._s(_vm.$t("ib_regulatory_information_header"))),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "ib-row" }, [
        _c("div", { staticClass: "ib-col" }, [
          _c("p", { staticClass: "fs7 insety-8" }, [
            _vm._v(_vm._s(_vm.$t("ib_regulatory_information_para_1")) + " "),
          ]),
          _c("p", { staticClass: "fs7 insety-8" }, [
            _vm._v(_vm._s(_vm.$t("ib_regulatory_information_para_2")) + " "),
          ]),
          _c("p", { staticClass: "fs7 insety-8" }, [
            _vm._v(_vm._s(_vm.$t("ib_regulatory_information_para_3")) + " "),
          ]),
          _c(
            "span",
            { staticClass: "insety-32" },
            [
              _c(
                "ib-button",
                {
                  staticClass: "insety-16",
                  attrs: { tone: "sell", appearance: "link" },
                  on: { click: _vm.getUrlIBAnnualFinStatement },
                },
                [
                  _vm._v(_vm._s(_vm.$t("ib_financial_statements"))),
                  _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                    _c("path", {
                      attrs: { d: "M15 4l7 7-7 7v-4C3 14 2 19 2 19S3 8 15 8z" },
                    }),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("hr", { staticClass: "before-24" }),
      _c("div", { staticClass: "ib-row grow insety-16" }, [
        _c("div", { staticClass: "ib-col" }, [
          _c("p", { staticClass: "fs3 insety-16" }, [
            _vm._v(_vm._s(_vm.$t("fin_info"))),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "panel",
          class: { active: this.isCapital === true },
          on: {
            click: function ($event) {
              return _vm.expand(1)
            },
          },
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.isCapital == false,
                  expression: "this.isCapital == false",
                },
              ],
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                _c("path", {
                  attrs: {
                    d: "M14.98 2.98a2 2 0 0 0-1.4 3.43L32.19 25l-18.6 18.59a2 2 0 1 0 2.83 2.82l20-20a2 2 0 0 0 0-2.82l-20-20a2 2 0 0 0-1.43-.61z",
                  },
                }),
              ]),
            ]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.isCapital == true,
                  expression: "this.isCapital == true",
                },
              ],
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                _c("path", {
                  attrs: {
                    d: "M44.98 12.97c-.53.01-1.03.23-1.4.62L25 32.17 6.41 13.6a2 2 0 0 0-2.83 2.83l20 20a2 2 0 0 0 2.83 0l20-20a2 2 0 0 0-1.43-3.45z",
                  },
                }),
              ]),
            ]
          ),
          _c("span", { staticClass: "insetx-8" }, [
            _vm._v(_vm._s(_vm.$t("capital"))),
          ]),
        ]
      ),
      _c("Capital", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: this.isCapital,
            expression: "this.isCapital",
          },
        ],
        attrs: { netCapitalList: _vm.netCapitalList },
      }),
      _c(
        "div",
        {
          staticClass: "panel",
          class: {
            active: this.isCustomerMoneySegregationComputations === true,
          },
          on: {
            click: function ($event) {
              return _vm.expand(2)
            },
          },
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.isCustomerMoneySegregationComputations == false,
                  expression:
                    "this.isCustomerMoneySegregationComputations == false",
                },
              ],
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                _c("path", {
                  attrs: {
                    d: "M14.98 2.98a2 2 0 0 0-1.4 3.43L32.19 25l-18.6 18.59a2 2 0 1 0 2.83 2.82l20-20a2 2 0 0 0 0-2.82l-20-20a2 2 0 0 0-1.43-.61z",
                  },
                }),
              ]),
            ]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.isCustomerMoneySegregationComputations == true,
                  expression:
                    "this.isCustomerMoneySegregationComputations == true",
                },
              ],
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                _c("path", {
                  attrs: {
                    d: "M44.98 12.97c-.53.01-1.03.23-1.4.62L25 32.17 6.41 13.6a2 2 0 0 0-2.83 2.83l20 20a2 2 0 0 0 2.83 0l20-20a2 2 0 0 0-1.43-3.45z",
                  },
                }),
              ]),
            ]
          ),
          _c("span", { staticClass: "insetx-8" }, [
            _vm._v(_vm._s(_vm.$t("cust_money_seg"))),
          ]),
        ]
      ),
      _c("CustomerMoneySegregationComputation", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: this.isCustomerMoneySegregationComputations,
            expression: "this.isCustomerMoneySegregationComputations",
          },
        ],
        attrs: {
          CommodityDomesticSegregationList:
            _vm.CommodityDomesticSegregationList,
          CommodityForeignSegregationList: _vm.CommodityForeignSegregationList,
          CommoditySwapSegregationList: _vm.CommoditySwapSegregationList,
          Securities15c3SegregationList: _vm.Securities15c3SegregationList,
        },
      }),
      _c(
        "div",
        {
          staticClass: "panel",
          class: { active: this.isFutureCustomerConcentration === true },
          on: {
            click: function ($event) {
              return _vm.expand(3)
            },
          },
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.isFutureCustomerConcentration == false,
                  expression: "this.isFutureCustomerConcentration == false",
                },
              ],
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                _c("path", {
                  attrs: {
                    d: "M14.98 2.98a2 2 0 0 0-1.4 3.43L32.19 25l-18.6 18.59a2 2 0 1 0 2.83 2.82l20-20a2 2 0 0 0 0-2.82l-20-20a2 2 0 0 0-1.43-.61z",
                  },
                }),
              ]),
            ]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.isFutureCustomerConcentration == true,
                  expression: "this.isFutureCustomerConcentration == true",
                },
              ],
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                _c("path", {
                  attrs: {
                    d: "M44.98 12.97c-.53.01-1.03.23-1.4.62L25 32.17 6.41 13.6a2 2 0 0 0-2.83 2.83l20 20a2 2 0 0 0 2.83 0l20-20a2 2 0 0 0-1.43-3.45z",
                  },
                }),
              ]),
            ]
          ),
          _c("span", { staticClass: "insetx-8" }, [
            _vm._v(_vm._s(_vm.$t("fut_cust_concent"))),
          ]),
        ]
      ),
      _c("FutureCustomerConcentration", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: this.isFutureCustomerConcentration,
            expression: "this.isFutureCustomerConcentration",
          },
        ],
        attrs: { Cust50PercentNetLiqList: _vm.Cust50PercentNetLiqList },
      }),
      _c(
        "div",
        {
          staticClass: "panel",
          class: { active: this.isFutureMarginRequirements === true },
          on: {
            click: function ($event) {
              return _vm.expand(4)
            },
          },
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.isFutureMarginRequirements == false,
                  expression: "this.isFutureMarginRequirements == false",
                },
              ],
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                _c("path", {
                  attrs: {
                    d: "M14.98 2.98a2 2 0 0 0-1.4 3.43L32.19 25l-18.6 18.59a2 2 0 1 0 2.83 2.82l20-20a2 2 0 0 0 0-2.82l-20-20a2 2 0 0 0-1.43-.61z",
                  },
                }),
              ]),
            ]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.isFutureMarginRequirements == true,
                  expression: "this.isFutureMarginRequirements == true",
                },
              ],
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                _c("path", {
                  attrs: {
                    d: "M44.98 12.97c-.53.01-1.03.23-1.4.62L25 32.17 6.41 13.6a2 2 0 0 0-2.83 2.83l20 20a2 2 0 0 0 2.83 0l20-20a2 2 0 0 0-1.43-3.45z",
                  },
                }),
              ]),
            ]
          ),
          _c("span", { staticClass: "insetx-8" }, [
            _vm._v(_vm._s(_vm.$t("fut_mar_req"))),
          ]),
        ]
      ),
      _c("FuturesMarginRequirements", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: this.isFutureMarginRequirements,
            expression: "this.isFutureMarginRequirements",
          },
        ],
        attrs: { netCapitalList: _vm.netCapitalList },
      }),
      _c("hr", { staticClass: "before-32" }),
      _c("div", { staticClass: "ib-row grow insety-16" }, [
        _c("div", { staticClass: "ib-col" }, [
          _c("p", { staticClass: "fs3 insety-16" }, [
            _vm._v(" " + _vm._s(_vm.$t("reg_disclosures_header"))),
          ]),
          _c("span", [
            _c("p", { staticClass: "fs7 insety-8" }, [
              _vm._v(_vm._s(_vm.$t("reg_disclosures_para_1"))),
            ]),
          ]),
          _c("span", { staticClass: "insety-16" }, [
            _c(
              "a",
              {
                staticClass: "fs7 fg-sell",
                attrs: {
                  target: "_blank",
                  href: "https://gdcdyn.interactivebrokers.com/Universal/servlet/Registration_v2.formSampleView?formdb=3355",
                },
              },
              [
                _vm._v(_vm._s(_vm.$t("reg_disclosures_link"))),
                _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                  _c("path", {
                    attrs: { d: "M15 4l7 7-7 7v-4C3 14 2 19 2 19S3 8 15 8z" },
                  }),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _c("hr", { staticClass: "before-32" }),
      _c("div", { staticClass: "ib-row grow insety-16" }, [
        _c("div", { staticClass: "ib-col" }, [
          _c("p", { staticClass: "fs3 insety-16" }, [
            _vm._v(_vm._s(_vm.$t("add_info_header"))),
          ]),
          _c("span", [
            _c("p", { staticClass: "fs7" }, [
              _vm._v(_vm._s(_vm.$t("add_info_para_1_1")) + " "),
              _c(
                "a",
                {
                  staticClass: "fg-sell",
                  attrs: {
                    href: "http://www.nfa.futures.org/basicnet/",
                    target: "_blank",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("add_info_nfa_link")))]
              ),
              _vm._v(" " + _vm._s(_vm.$t("add_info_para_1_2"))),
            ]),
          ]),
          _c("span", [
            _c("p", { staticClass: "bold fs7 insety-8" }, [
              _vm._v(_vm._s(_vm.$t("add_info_para_2")) + "  "),
              _c(
                "a",
                {
                  staticClass: "fg-sell",
                  attrs: {
                    href: "http://www.cftc.gov/MarketReports/financialfcmdata/index.htm",
                    target: "_blank",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("here")))]
              ),
              _vm._v(".        "),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }